export const createEnquiry = async (formData) => {
  // REACT_APP_API_BASE is set at build time when the API is on another host (Amplify); empty = same site
  const response = await fetch(`${process.env.REACT_APP_API_BASE || ""}/api/send-enquiry`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error("Failed to send enquiry");
  }

  return await response.json();
};
